// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__2teqZ","variantWhite":"Button_variantWhite__1nxBI","variantBlue":"Button_variantBlue__k_94v"};